/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { Form, Input } from 'semantic-ui-react'

export default class ShareExpense extends React.PureComponent {
  render() {
    const { value, label, onChange } = this.props

    return (
      <Form.Field required>
        <label>{label}</label>
        <Input
          label={{ content: '%' }}
          labelPosition="right"
          placeholder="e.g 10"
          type="number"
          required
          onChange={e => onChange(e.target.value)}
          value={value}
          step={0.01}
          min={0}
          max={100}
        />
      </Form.Field>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/promotions/fields/shareExpense.js